export default function () {
    return {
        assemblydata: {},
        stages: {},
        users: {},
        milestones: {},
        sessionData: {},
    };
}
